import React, { useState, useEffect } from "react";
import Dialog from "../MyUI/Dialog/Dialog"; // import the modal
import "./Footer.css";

export default function Footer() {
  const [showFooter, setShowFooter] = useState(true);

  // Modal state
  const [showChangeLogs, setShowChangeLogs] = useState(false);

  // Open modal
  const openChangeLogs = () => {
    setShowChangeLogs(true);
  };

  useEffect(() => {
    
  }, []);

  return (
    <div>
      {/* Centered Chevron */}
      <div
        className="chevronFooter"
        onClick={() => setShowFooter(!showFooter)}
      >
        <svg
          viewBox="0 0 24 24"
          width="22"
          height="22"
          style={{ transform: showFooter ? "rotate(0deg)" : "rotate(180deg)", fill: "#6d7176" }}
        >
          <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"></path>
        </svg>
      </div>

      {/* Footer */}
      <div className={showFooter ? "Footer footer-fadeIn" : "Footer footer-fadeOut"}>
        <button className="label-btn" onClick={openChangeLogs}>View Change Logs</button>
        <div style={{ flex: 1 }}></div>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://wiki.et-gw.eu"
        >
          Documentation
        </a>
        {"\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"} {/* 6 non-breaking spaces */}
        <a href="mailto:p.verdier@ip2i.in2p3.fr,o.el-mecherfi@ip2i.in2p3.fr">
          Contact Us
        </a>
      </div>

      <Dialog open={showChangeLogs} onClose={() => setShowChangeLogs(false)}>
        <h2>Change Logs</h2>
        <p>v 1.1 enjoy !</p>
        <button className="label-btn" onClick={() => setShowChangeLogs(false)}>Close</button>
      </Dialog>
    </div>
  );
}
